// extracted by mini-css-extract-plugin
export default {"container":"CameraSettingDropdown_container__BGN73","cameraSetting":"CameraSettingDropdown_cameraSetting__tjl7X"};